import { render, staticRenderFns } from "./MedPadalaError.vue?vue&type=template&id=64e01d66&"
import script from "./MedPadalaError.vue?vue&type=script&lang=js&"
export * from "./MedPadalaError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports